module.exports = __webpack_public_path__ + "assets/img/rangesetting.48fa5d63.svg";